import { render, staticRenderFns } from "./ram.vue?vue&type=template&id=3751867f"
import script from "./ram.vue?vue&type=script&lang=js"
export * from "./ram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports